import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Security from "./Security";
import { useEffect } from "react";
import axios from "axios";
import secureLocalStorage from "./storage";
import Manubar from "./Manubar";
import { ToastContainer, toast } from "react-toastify";
import { BsFillSuitHeartFill } from "react-icons/bs";
import "./loader.css";
import "./shubh.css";
import { useCart } from "./CartContext";

const itemsPerPage = 8;

const SearchProducts = () => {
  let navigate = useNavigate();
  const { triggerCartRefresh } = useCart();
  const location = useLocation();

  const searchnamelist =
    location.state?.searchname ||
    localStorage.getItem("searchname");

  const [slideIndex, setSlideIndex] = useState(0);
  let [images, setimages] = useState([null]);

  const plusSlides = (n) => {
    const newIndex = (slideIndex + n + images.length) % images.length;
    setSlideIndex(newIndex);
  };

  const currentSlide = (n) => {
    setSlideIndex(n);
  };

  // useState variables
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [cardstatus, setcardstatus] = useState(true);
  let [product_details, setproduct_details] = useState([]);
  let [showmodel, setshowmodel] = useState([]);
  let [counter, setcounter] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentProductId, setCurrentProductId] = useState(null);
  
  // New state for modal
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!searchnamelist) return;
    fetchData(searchnamelist);
  }, [searchnamelist]);

  const fetchData = async (searchnamelist) => {
    try {
      let data = {
        user_id: _id,
        product_name: searchnamelist,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/all_search_product_name`,
        data
      );

      if (res?.data?.result) {
        setproduct_details(res.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const totalPages = Math.ceil(product_details.length / itemsPerPage);
  const handleChangePage = (newPage) => {
    setCurrentPage(newPage);
  };
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = product_details.slice(startIndex, endIndex);

  let Single_products_model = (singleproducts) => {
    setCurrentProductId(singleproducts);
    setModalOpen(true);

    try {
      let items = {
        product_id: singleproducts,
        user_id: _id,
      };

      axios
        .post(`${process.env.REACT_APP_API}website/product_details`, items)
        .then((res) => {
          if (res.data.result) {
            setimages(res.data.data[0]?.product_image);
            setshowmodel(res.data.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  let Single_products = (singleproducts) => {
     navigate(`/single_products/${singleproducts}`);
  };

  const closemodal = () => {
    setModalOpen(false);
    setshowmodel([]);
    setcounter(1);
  };

  let removelocal_showcard = () => {
    setshowmodel(null);
    secureLocalStorage.setItem("n_singleproducts", null);
  };

  let [indexvalue, setindex_vlaue] = useState(0);
  let qantity_index = (indexid) => {
    setindex_vlaue(indexid);
  };

  const add_to_cart = async (cart) => {
    try {
      const data = {
        user_id: _id,
        product_id: cart.product_id,
        quantity: "1kg",
        no_of_product: 1,
        mrp: cart.mrp,
        price: cart.price?.[0],
        total_mrp_ammount: cart.mrp,
        total_price_ammount: cart.price?.[0],
        product_name: cart.product_name,
        product_image: cart.product_image?.[0],
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_to_cart`,
        data,
        { headers: { token } }
      );

      if (res.data?.result) {
        setcardstatus(true);
        secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        triggerCartRefresh();
        toast.success("Product added to cart successfully ✅");
        fetchData(searchnamelist);
      } else {
        toast.error(res.data?.msg || "Failed to add item to cart");
        setcardstatus(false);
      }
    } catch (error) {
      console.log("Add to cart error:", error);
      toast.error("Something went wrong while adding to cart");
      setcardstatus(false);
    }
  };

  const counter_price = showmodel?.[0]?.price?.[indexvalue] * counter;
  let increment = () => {
    setcounter(counter + 1);
  };

  let decrement = () => {
    if (counter > 1) {
      setcounter(counter - 1);
    }
  };

  const add_to_cart_model = async (modeldata) => {
    try {
      const data = {
        user_id: _id,
        product_id: modeldata?._id,
        quantity: modeldata?.quantity?.[indexvalue],
        no_of_product: counter,
        mrp: modeldata?.mrp,
        price: modeldata?.price?.[indexvalue],
        total_mrp_ammount: modeldata?.mrp,
        total_price_ammount: counter_price,
        product_name: modeldata?.product_name,
        product_image: modeldata?.product_image?.[0],
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_to_cart`,
        data,
        { headers: { token } }
      );

      if (res.data?.result) {
        setcardstatus(true);
        secureLocalStorage.setItem("n_cartlist_id", res.data.data._id);
        triggerCartRefresh();
        
        // Update the current modal data
        try {
          let items = {
            product_id: currentProductId,
            user_id: _id,
          };
          axios
            .post(`${process.env.REACT_APP_API}website/product_details`, items)
            .then((res) => {
              if (res.data.result) {
                setshowmodel(res.data.data);
              }
            });
        } catch (error) {
          console.log(error);
        }
        
        toast.success("Product added to cart successfully ✅");
      } else {
        toast.error(res.data?.msg || "Failed to add product to cart");
        setcardstatus(false);
      }
    } catch (error) {
      console.log("Add to cart (modal) error:", error);
      toast.error("Something went wrong while adding to cart");
      setcardstatus(false);
    }
  };

  const addfevrate = async (productsid, fav_status) => {
    try {
      const items = {
        user_id: _id,
        product_id: currentProductId || productsid,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/add_favourite_product`,
        items,
        {
          headers: { token },
        }
      );

      if (res.data.result) {
        toast.success(res.data.msg);
        triggerCartRefresh();
        fetchData(searchnamelist);
        
        // Update modal data if modal is open
        if (modalOpen && currentProductId) {
          try {
            let items = {
              product_id: currentProductId,
              user_id: _id,
            };
            axios
              .post(`${process.env.REACT_APP_API}website/product_details`, items)
              .then((res) => {
                if (res.data.result) {
                  setshowmodel(res.data.data);
                }
              });
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        toast.error(res.data.msg || "Something went wrong");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
      fetchData(searchnamelist);
    }
  };

  return (
    <div>
      <ToastContainer position="top-center" />

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>
      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Search Results
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      <div className="container mt-4">
        <div className="row justify-content-center">
          {currentData.length > 0 ? (
            currentData?.map((items) => {
              return (
                <div
                  className="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12"
                  key={items.product_id}
                >
                  <div
                    className="product-card"
                    style={{
                      margin: "0 5px 15px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      borderRadius: "20px",
                      overflow: "hidden",
                      minHeight: "363px",
                      background: "#ffffff",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                      position: "relative",
                      border: "1px solid #f0f0f0",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.12)";
                      e.currentTarget.style.transform = "translateY(-5px)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.08)";
                      e.currentTarget.style.transform = "translateY(0)";
                    }}
                  >
                    {items.offer_percent !== 0 && (
                      <div
                        className="badge product-badge"
                        style={{
                          position: "absolute",
                          top: "15px",
                          left: "15px",
                          // background: "linear-gradient(135deg, #ff6a00 0%, #ee0979 100%)",
                               background: "linear-gradient(135deg, #ff4b2b, #c01e12)",
                          color: "#fff",
                          borderRadius: "20px",
                          padding: "6px 14px",
                          fontWeight: "700",
                          zIndex: 2,
                          fontSize: "12px",
                          boxShadow: "0 4px 12px rgba(228, 34, 9, 0.93)"
                        }}
                      >
                        {items.offer_percent}% OFF
                      </div>
                    )}

                    <div
                      className="product-thumb-nail"
                      onClick={() => Single_products(items.product_id)}
                      style={{
                        position: "relative",
                        padding: "25px 20px 15px",
                        background: "linear-gradient(180deg, #fff5f0 0%, #ffffff 100%)",
                        flex: "0 0 auto",
                        minHeight: "200px"
                      }}
                    >
                      <img
                        className="product-image"
                        src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                        alt={items.product_name}
                        style={{
                          width: "100%",
                          height: "180px",
                          objectFit: "contain",
                          transition: "transform 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.05)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "scale(1)";
                        }}
                      />

                      <div
                        className="actions"
                        style={{
                          position: "absolute",
                          top: "103px",
                          right: "15px",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-around"
                        }}
                      >
                        {token ? (
                          items.favourite_status == 1 ? (
                            <button
                              className="action-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                addfevrate(items.product_id, items.favourite_status);
                              }}
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                background: "rgba(255, 255, 255, 0.9)",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                              }}
                              onMouseEnter={(e) => {
                                if (e.currentTarget.querySelector('svg')) {
                                  e.currentTarget.querySelector('svg').style.color = "rgb(255, 161, 29)";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (e.currentTarget.querySelector('svg')) {
                                  e.currentTarget.querySelector('svg').style.color = "#ff4757";
                                }
                              }}
                            >
                              <BsFillSuitHeartFill
                                style={{
                                  color: "#ff4757",
                                  fontSize: "18px",
                                  transition: "all 0.2s ease"
                                }}
                              />
                            </button>
                          ) : (
                            <button
                              className="action-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                addfevrate(items.product_id, items.favourite_status);
                              }}
                              style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                background: "rgba(255, 255, 255, 0.9)",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                              }}
                              onMouseEnter={(e) => {
                                if (e.currentTarget.querySelector('i')) {
                                  e.currentTarget.querySelector('i').style.color = "rgb(233, 57, 13)";
                                }
                              }}
                              onMouseLeave={(e) => {
                                if (e.currentTarget.querySelector('i')) {
                                  e.currentTarget.querySelector('i').style.color = "#666";
                                }
                              }}
                            >
                              <i className="lar la-heart" style={{
                                fontSize: "18px",
                                color: "#666",
                                transition: "all 0.2s ease"
                              }} />
                            </button>
                          )
                        ) : (
                          <a
                            href="/login"
                            onClick={(e) => e.stopPropagation()}
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "50%",
                              background: "rgba(255, 255, 255, 0.9)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                              textDecoration: "none",
                              transition: "all 0.2s ease"
                            }}
                            onMouseEnter={(e) => {
                              if (e.currentTarget.querySelector('i')) {
                                e.currentTarget.querySelector('i').style.color = "rgb(255, 161, 29)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (e.currentTarget.querySelector('i')) {
                                e.currentTarget.querySelector('i').style.color = "#666";
                              }
                            }}
                          >
                            <i className="lar la-heart" style={{
                              fontSize: "18px",
                              color: "#666",
                              transition: "all 0.2s ease"
                            }} />
                          </a>
                        )}

                        <button
                          className="action-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            Single_products_model(items.product_id);
                          }}
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            background: "rgba(255, 255, 255, 0.9)",
                            border: "none",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                            cursor: "pointer",
                            transition: "all 0.2s ease"
                          }}
                          onMouseEnter={(e) => {
                            if (e.currentTarget.querySelector('i')) {
                              e.currentTarget.querySelector('i').style.color = "rgb(255, 161, 29)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (e.currentTarget.querySelector('i')) {
                              e.currentTarget.querySelector('i').style.color = "#666";
                            }
                          }}
                        >
                          <i className="las la-eye" style={{
                            fontSize: "18px",
                            color: "#666",
                            transition: "all 0.2s ease"
                          }} />
                        </button>
                      </div>
                    </div>

                    <div
                      className="product-content"
                      onClick={() => Single_products(items.product_id)}
                      style={{
                        padding: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flex: "1 0 auto",
                        background: "#ffffff"
                      }}
                    >
                      <div>
                        <div
                          className="product-sub-title"
                          style={{
                            fontSize: "12px",
                            color: "#666",
                            fontWeight: "500",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                            marginBottom: "8px"
                          }}
                        >
                          {items.category_name}
                        </div>

                        <h3
                          className="product-title"
                          style={{
                            fontSize: "16px",
                            fontWeight: "600",
                            color: "#333",
                            lineHeight: "1.4",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            marginBottom: "0px"
                          }}
                        >
                          {items.product_name}
                        </h3>

                        <div
                          className="product-price-wrapp"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px"
                          }}
                        >
                          {items.offer_percent !== 0 && (
                            <span
                              className="product-regular-price"
                              style={{
                                fontSize: "14px",
                                textDecoration: "line-through",
                                color: "#999",
                                fontWeight: "500"
                              }}
                            >
                              ₹{items.mrp}
                            </span>
                          )}
                          <span
                            className="product-price-on-sale"
                            style={{
                              fontWeight: "700",
                              fontSize: "20px",
                              color: "rgb(255, 161, 29)",
                              display: "inline-block"
                            }}
                          >
                            ₹{items?.price?.[0]}
                          </span>
                        </div>
                      </div>

                      <div className="product-cart-btn-wrap">
                        {token ? (
                          items.cart_status === "1" ? (
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/cardlist");
                              }}
                              className="btn w-100 py-2"
                              style={{
                                borderRadius: "12px",
                                fontWeight: "600",
                                fontSize: "14px",
                                background: "rgb(255, 161, 29)",
                                color: "#fff",
                                border: "none",
                                transition: "all 0.2s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "rgb(230, 145, 26)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "rgb(255, 161, 29)";
                              }}
                            >
                              <i className="las la-shopping-cart" style={{ fontSize: "16px" }} />
                              Already in Cart
                            </button>
                          ) : (
                            <button
                              className="btn w-100 py-2"
                              onClick={(e) => {
                                e.stopPropagation();
                                add_to_cart(items);
                              }}
                              style={{
                                borderRadius: "12px",
                                fontWeight: "600",
                                color: "#fff",
                                background: "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))",
                                border: "none",
                                fontSize: "14px",
                                transition: "all 0.2s ease",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "8px"
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "linear-gradient(90deg, rgb(255, 138, 0), rgb(255, 106, 0), rgb(255, 61, 0))";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))";
                              }}
                            >
                              <i className="las la-cart-plus" style={{ fontSize: "16px" }} />
                              Add to Cart
                            </button>
                          )
                        ) : (
                          <a
                            href="/login"
                            className="btn w-100 py-2 text-white"
                            style={{
                              borderRadius: "12px",
                              fontWeight: "600",
                              fontSize: "14px",
                              background: "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                              textDecoration: "none",
                              transition: "all 0.2s ease"
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = "linear-gradient(90deg, rgb(255, 138, 0), rgb(255, 106, 0), rgb(255, 61, 0))";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))";
                            }}
                          >
                            <i className="las la-sign-in-alt" style={{ fontSize: "16px" }} />
                            Add to Cart
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="row justify-content-center pb-5">
              <div className="loader"></div>
            </div>
          )}
        </div>

        <div className="text-center p-4">
          <button
            className="pagination-button"
            disabled={currentPage === 1}
            onClick={() => handleChangePage(currentPage - 1)}
          >
            Previous
          </button>
          {pageNumbers.map((page) => (
            <button
              key={page}
              onClick={() => handleChangePage(page)}
              className={`pagination-button ${
                page === currentPage ? "pagiactive" : ""
              }`}
            >
              {page}
            </button>
          ))}
          <button
            className="pagination-button"
            disabled={currentPage === totalPages}
            onClick={() => handleChangePage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      </div>
      <Security />
      <Footer />

      {/* Modern Modal */}
      {modalOpen && (
        <div className="modal show d-block" tabIndex="-1" aria-hidden="true" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content" style={{
              borderRadius: '24px',
              border: 'none',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
            }}>
              {/* Modern Header with Gradient */}
              <div className="modal-header border-0 p-4" style={{
                background: 'linear-gradient(135deg, #ff9e16 0%, #ffbb5b 100%)',
                position: 'relative'
              }}>
                <h5 className="modal-title text-white mb-0">
                  <i className="fas fa-eye me-2"></i>
                  Product Details
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white close"
                  onClick={closemodal}
                  style={{
                    filter: 'brightness(0) invert(1)',
                    fontSize: '18px'
                  }}
                ></button>
              </div>

              {showmodel?.length > 0 ? (
                <div className="modal-body p-0">
                  <div className="row g-0">
                    {/* Image Section - Left */}
                    <div className="col-md-6 bg-light">
                      <div className="p-4 p-lg-5">
                        {/* Main Image with Modern Frame */}
                        <div className="position-relative mb-4">
                          <div className="bg-white rounded-4 p-4 shadow-sm" style={{
                            border: '1px solid #eef2f7',
                            minHeight: '380px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}>
                            {images && images.length > 0 && (
                              <>
                                <img
                                  src={`${process.env.REACT_APP_API}uploads/${images[slideIndex]}`}
                                  alt={showmodel[0]?.product_name}
                                  className="img-fluid"
                                  style={{
                                    maxHeight: '320px',
                                    objectFit: 'contain',
                                    transition: 'transform 0.3s ease'
                                  }}
                                />

                                {/* Image Counter Badge */}
                                <div className="position-absolute top-0 start-0 m-3">
                                  <span className="badge bg-dark bg-opacity-75 text-white px-3 py-2 rounded-pill">
                                    <i className="fas fa-image me-1"></i>
                                    {slideIndex + 1} / {images.length}
                                  </span>
                                </div>

                                {/* Modern Navigation Buttons */}
                                {images.length > 1 && (
                                  <>
                                    <button
                                      onClick={() => plusSlides(-1)}
                                      className="btn btn-light btn-lg rounded-circle shadow position-absolute start-0 ms-3"
                                      style={{
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '48px',
                                        height: '48px',
                                        background: 'rgba(255,255,255,0.9)',
                                        backdropFilter: 'blur(10px)'
                                      }}
                                    >
                                      <i className="fas fa-chevron-left"></i>
                                    </button>
                                    <button
                                      onClick={() => plusSlides(1)}
                                      className="btn btn-light btn-lg rounded-circle shadow position-absolute end-0 me-3"
                                      style={{
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '48px',
                                        height: '48px',
                                        background: 'rgba(255,255,255,0.9)',
                                        backdropFilter: 'blur(10px)'
                                      }}
                                    >
                                      <i className="fas fa-chevron-right"></i>
                                    </button>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        {/* Modern Thumbnail Gallery */}
                        {images && images.length > 1 && (
                          <div className="d-flex justify-content-center gap-3 overflow-auto pb-3">
                            {images.map((image, index) => (
                              <button
                                key={index}
                                onClick={() => currentSlide(index)}
                                className={`flex-shrink-0 border-2 rounded-3 overflow-hidden p-1 ${index === slideIndex ? 'border-primary' : 'border-light'}`}
                                style={{
                                  width: '80px',
                                  height: '80px',
                                  background: 'white',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.05)'}
                                onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                              >
                                <img
                                  src={`${process.env.REACT_APP_API}uploads/${image}`}
                                  alt={`Thumbnail ${index + 1}`}
                                  className="img-fluid rounded-2"
                                  style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                  }}
                                />
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Product Info Section - Right */}
                    <div className="col-md-6">
                      <div className="p-4 p-lg-5 h-100">
                        {/* Product Title & Category */}
                        <div className="mb-4">
                          <div className="d-flex align-items-center gap-2 mb-3">
                            <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill">
                              <i className="fas fa-tag me-2"></i>
                              {showmodel[0]?.category_name}
                            </span>
                            {showmodel[0]?.offer_percent > 0 && (
                              <span className="badge bg-danger text-white px-3 py-2 rounded-pill">
                                <i className="fas fa-bolt me-2"></i>
                                -{showmodel[0]?.offer_percent}% OFF
                              </span>
                            )}
                          </div>

                          <h2 className="h3 fw-bold text-dark mb-3" style={{ lineHeight: '1.3' }}>
                            {showmodel[0]?.product_name}
                          </h2>

                          {/* Modern Rating */}
                          <div className="d-flex align-items-center gap-3 mb-4">
                            <div className="text-warning">
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star"></i>
                              <i className="fas fa-star-half-alt"></i>
                            </div>
                          </div>
                        </div>

                        {/* Modern Price Display */}
                        <div className="mb-4 p-4 rounded-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)' }}>
                          <div className="d-flex align-items-end gap-3 mb-2">
                            <span className="h2 fw-bold text-success">
                              ₹{counter_price}
                            </span>
                            {showmodel[0]?.mrp > counter_price && (
                              <>
                                <span className="h5 text-muted text-decoration-line-through">
                                  ₹{showmodel[0]?.mrp}
                                </span>
                                <span className="badge bg-success text-white px-3 py-2 rounded-pill">
                                  <i className="fas fa-save me-1"></i>
                                  Save ₹{showmodel[0]?.mrp - counter_price}
                                </span>
                              </>
                            )}
                          </div>
                        </div>

                        {/* Description */}
                        <div className="mb-4">
                          <h6 className="text-uppercase text-muted small fw-bold mb-3">
                            <i className="fas fa-info-circle me-2"></i>
                            Description
                          </h6>
                          <p className="text-dark mb-0" style={{ lineHeight: '1.6', fontSize: '15px' }}>
                            {showmodel[0]?.description}
                          </p>
                        </div>

                        {/* Quantity Variants */}
                        {showmodel[0]?.quantity?.length > 0 && (
                          <div className="mb-4">
                            <h6 className="text-uppercase text-muted small fw-bold mb-3">
                              <i className="fas fa-box me-2"></i>
                              Available Sizes
                            </h6>
                            <div className="d-flex flex-wrap gap-2">
                              {showmodel[0]?.quantity.map((item, index) => (
                                <button
                                  key={index}
                                  onClick={() => qantity_index(index)}
                                  className={`btn ${index === indexvalue ? 'btn-success' : 'btn-outline-success'} m-1 rounded-pill px-4 py-2`}
                                  style={{
                                    transition: 'all 0.3s ease',
                                    borderWidth: '2px'
                                  }}
                                  onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                                  }}
                                  onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                  }}
                                >
                                  {item}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Quantity & Add to Cart - Modern Layout */}
                        <div className="mb-4">
                          <h6 className="text-uppercase text-muted small fw-bold mb-3">
                            <i className="fas fa-sort-amount-up me-2"></i>
                            Quantity
                          </h6>
                          <div className="row g-3 align-items-center">
                            <div className="col-md-4">
                              <div className="input-group input-group-lg border rounded-4 overflow-hidden">
                                <button
                                  onClick={decrement}
                                  className="btn btn-light border-0 px-3 py-3"
                                >
                                  <i className="fas fa-minus"></i>
                                </button>
                                <input
                                  type="text"
                                  className="form-control border-0 text-center fs-5 fw-bold"
                                  value={counter}
                                  readOnly
                                  style={{ maxWidth: '70px' }}
                                />
                                <button
                                  onClick={increment}
                                  className="btn btn-light border-0 px-3 py-3"
                                >
                                  <i className="fas fa-plus"></i>
                                </button>
                              </div>
                            </div>

                            <div className="col-md-8">
                              {token ? (
                                showmodel[0]?.cart_status === "1" ? (
                                  <button
                                    onClick={() => {
                                      navigate("/cardlist");
                                      closemodal();
                                    }}



                                style={{
                              
                                background: "rgb(255, 161, 29)",
                               
                                transition: 'all 0.3s ease',
                                      border: 'none'
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "rgb(230, 145, 26)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "rgb(255, 161, 29)";
                              }}

                                    className="btn  btn-lg w-100 py-3 rounded-4 fw-bold"
                                  
                                    
                                  >
                                    <i className="fas fa-shopping-cart me-2"></i>
                                    View in Cart
                                  </button>
                                ) : (
                                  <button
                                    onClick={() => add_to_cart_model(showmodel[0])}
                                    className="btn w-100 py-3 rounded-4 fw-bold"
                                    style={{
                                      transition: 'all 0.3s ease',
                                      border: 'none',
                                        background: "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))",

                                    }}
                                   
                               
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "linear-gradient(90deg, rgb(255, 138, 0), rgb(255, 106, 0), rgb(255, 61, 0))";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "linear-gradient(90deg, rgb(255, 161, 29), rgb(255, 123, 0), rgb(255, 85, 0))";
                              }}
                                  >
                                    <i className="fas fa-shopping-cart me-2"></i>
                                    Add to Cart
                                  </button>
                                )
                              ) : (
                                <a
                                  href="/login"
                                  className="btn btn-primary w-100 py-3 rounded-4 fw-bold text-decoration-none"
                                  style={{
                                    transition: 'all 0.3s ease',
                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                    border: 'none',
                                    display: 'block'
                                  }}
                                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                  <i className="fas fa-sign-in-alt me-2"></i>
                                  Login to Purchase
                                </a>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Modern Wishlist Button */}
                        <div className="row g-3 mb-4">
                          <div className="col-md-12">
                            {token ? (
                              showmodel[0]?.favourite_status == 1 ? (
                                <button
                                  onClick={() => addfevrate(showmodel[0]?._id, showmodel[0]?.favourite_status)}
                                  className="btn btn-outline-danger w-100 py-3 rounded-4 fw-bold"
                                  style={{
                                    transition: 'all 0.3s ease',
                                    borderWidth: '2px'
                                  }}
                                  onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(220,53,69,0.2)';
                                  }}
                                  onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                  }}
                                >
                                  <i className="fas fa-heart me-2"></i>
                                  Remove from Wishlist
                                </button>
                              ) : (
                                <button
                                  onClick={() => addfevrate(showmodel[0]?._id, showmodel[0]?.favourite_status)}
                                  className="btn btn-outline-secondary w-100 py-3 rounded-4 fw-bold"
                                  style={{
                                    transition: 'all 0.3s ease',
                                    borderWidth: '2px'
                                  }}
                                  onMouseEnter={e => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                                  }}
                                  onMouseLeave={e => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = 'none';
                                  }}
                                >
                                  <i className="far fa-heart me-2"></i>
                                  Add to Wishlist
                                </button>
                              )
                            ) : (
                              <a
                                href="/login"
                                className="btn btn-outline-secondary w-100 py-3 rounded-4 fw-bold text-decoration-none"
                                style={{
                                  transition: 'all 0.3s ease',
                                  borderWidth: '2px',
                                  display: 'block'
                                }}
                                onMouseEnter={e => {
                                  e.currentTarget.style.transform = 'translateY(-2px)';
                                  e.currentTarget.style.boxShadow = '0 5px 15px rgba(0,0,0,0.1)';
                                }}
                                onMouseLeave={e => {
                                  e.currentTarget.style.transform = 'translateY(0)';
                                  e.currentTarget.style.boxShadow = 'none';
                                }}
                              >
                                <i className="far fa-heart me-2"></i>
                                Login for Wishlist
                              </a>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                /* Modern Loading Animation */
                <div className="modal-body d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '500px' }}>
                  <div className="spinner-border text-primary mb-4" style={{
                    width: '50px',
                    height: '50px',
                    borderWidth: '3px'
                  }} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {modalOpen && <div className="modal-backdrop show"></div>}

      <div className="modal fade" id="shopaddcard">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-dark border-bottom-0 justify-content-center">
              <h4 className="modal-title text-center text-white">
                {cardstatus == true
                  ? "Product successfully added to your shopping cart"
                  : "Already added to your shopping cart"}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchProducts;

